// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === General Dashboard Container === */
.dashboard-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  font-family: Arial, sans-serif;
  min-height: calc(100vh - 40px);
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f9f9f9;
  box-sizing: border-box;
  gap: 20px;
}

.dashboard-container h1 {
  text-align: center;
  margin-bottom: 10px;
  color: #333;
}

/* === Dashboard Grid Cards === */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.dashboard-card {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.dashboard-card:hover {
  transform: scale(1.02);
}

.dashboard-card h3 {
  color: #333;
  font-size: 18px;
  margin-bottom: 10px;
}

.dashboard-card p {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}

.dashboard-link {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}

.dashboard-link:hover {
  text-decoration: underline;
}

/* === Navbar === */
.dashboard-navbar {
  background-color: #f8f9fa;
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  position: relative;
  z-index: 1000;
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.dashboard-navbar ul {
  list-style: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;
}

.dashboard-navbar ul li {
  display: inline-block;
}

.dashboard-navbar ul li a {
  text-decoration: none;
  color: #007bff;
  font-weight: bold;
  padding: 8px 15px;
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.dashboard-navbar ul li a.active,
.dashboard-navbar ul li a:hover {
  color: white;
  background-color: #007bff;
}

/* === Form Styling === */
form {
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

form h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #444;
}

form input,
form textarea {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
}

form button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

form button:hover {
  background-color: #0056b3;
}

/* === Tables === */
table {
  width: 100%;
  max-width: 1200px;
  border-collapse: collapse;
  margin: 20px 0;
  text-align: center;
}

table thead {
  background-color: #007bff;
  color: white;
}

table th,
table td {
  text-align: left;
  padding: 10px;
  border: 1px solid #ddd;
}

table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

table tbody tr:hover {
  background-color: #f1f1f1;
}

/* === Pagination === */
.pagination {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 20px 0;
}

.pagination li button {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f0f0f0;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination li button.active,
.pagination li button:hover {
  background-color: #007bff;
  color: white;
}

/* === Modal === */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

/* Dashboard Summary Section */
.dashboard-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

/* Dashboard Cards */
.dashboard-card {
  background: #fff;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.dashboard-card h3 {
  margin-bottom: 10px;
  font-size: 18px;
  color: #333;
}

.dashboard-card-value {
  font-size: 24px;
  font-weight: bold;
  color: #007bff;
}

/* Dashboard Table */
.dashboard-table {
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.dashboard-table th,
.dashboard-table td {
  text-align: left;
  padding: 10px;
  border: 1px solid #ddd;
}

.dashboard-table thead {
  background-color: #007bff;
  color: #fff;
}

.dashboard-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.dashboard-table tbody tr:hover {
  background-color: #f1f1f1;
}

/* Action Buttons */
.dashboard-action-btn {
  margin: 0 5px;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  color: #fff;
  background-color: #007bff;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dashboard-action-btn:hover {
  background-color: #0056b3;
}

.dashboard-container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 15px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.card h3 {
  color: #333;
  margin-bottom: 10px;
}

.card p {
  color: #666;
  margin-bottom: 15px;
}

.card button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.card button:hover {
  background-color: #0056b3;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.popup-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.cancel-button {
  background: #f44336;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-button:hover {
  background: #d32f2f;
}

/* General Table Styles */
.table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 16px;
  text-align: left;
  background-color: #f9f9f9;
}

.table thead {
  background-color: #4CAF50;
  color: white;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 12px;
}

.table tr:hover {
  background-color: #f1f1f1;
}

/* Action Buttons Container */
.tab-buttons {
  display: flex;
  gap: 10px;
}

.tab-buttons button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.tab-buttons button:hover {
  opacity: 0.9;
}

/* Edit Button */
.tab-buttons button:nth-child(1) {
  background-color: #008CBA; /* Blue */
  color: white;
}

/* Delete Button */
.tab-buttons button:nth-child(2) {
  background-color: #f44336; /* Red */
  color: white;
}

.modal-content {
  max-height: 80vh;  /* Limits the height of the modal */
  overflow-y: auto;  /* Enables vertical scrolling */
  padding: 20px;
  border-radius: 8px;
  background-color: white;
}

.modal-backdrop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  background: transparent;
  border: none;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/css/dashboard.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,yBAAyB,EAAE,SAAS;EACpC,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,QAAQ;EACnC,YAAY;AACd;;AAEA;EACE,gBAAgB,GAAG,mCAAmC;EACtD,gBAAgB,GAAG,+BAA+B;EAClD,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb","sourcesContent":["/* === General Dashboard Container === */\n.dashboard-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px;\n  font-family: Arial, sans-serif;\n  min-height: calc(100vh - 40px);\n  max-width: 1200px;\n  margin: 0 auto;\n  background-color: #f9f9f9;\n  box-sizing: border-box;\n  gap: 20px;\n}\n\n.dashboard-container h1 {\n  text-align: center;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n/* === Dashboard Grid Cards === */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.dashboard-card {\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.dashboard-card:hover {\n  transform: scale(1.02);\n}\n\n.dashboard-card h3 {\n  color: #333;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.dashboard-card p {\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 15px;\n}\n\n.dashboard-link {\n  color: #007bff;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.dashboard-link:hover {\n  text-decoration: underline;\n}\n\n/* === Navbar === */\n.dashboard-navbar {\n  background-color: #f8f9fa;\n  padding: 15px 20px;\n  border-bottom: 1px solid #ddd;\n  position: relative;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  margin-top: 60px;\n}\n\n.dashboard-navbar ul {\n  list-style: none;\n  display: flex;\n  gap: 20px;\n  margin: 0;\n  padding: 0;\n}\n\n.dashboard-navbar ul li {\n  display: inline-block;\n}\n\n.dashboard-navbar ul li a {\n  text-decoration: none;\n  color: #007bff;\n  font-weight: bold;\n  padding: 8px 15px;\n  border-radius: 5px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.dashboard-navbar ul li a.active,\n.dashboard-navbar ul li a:hover {\n  color: white;\n  background-color: #007bff;\n}\n\n/* === Form Styling === */\nform {\n  max-width: 600px;\n  width: 100%;\n  margin: 0 auto;\n  background: #fff;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\nform h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #444;\n}\n\nform input,\nform textarea {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\nform button {\n  width: 100%;\n  padding: 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\nform button:hover {\n  background-color: #0056b3;\n}\n\n/* === Tables === */\ntable {\n  width: 100%;\n  max-width: 1200px;\n  border-collapse: collapse;\n  margin: 20px 0;\n  text-align: center;\n}\n\ntable thead {\n  background-color: #007bff;\n  color: white;\n}\n\ntable th,\ntable td {\n  text-align: left;\n  padding: 10px;\n  border: 1px solid #ddd;\n}\n\ntable tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\ntable tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* === Pagination === */\n.pagination {\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  padding: 0;\n  margin: 20px 0;\n}\n\n.pagination li button {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background-color: #f0f0f0;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pagination li button.active,\n.pagination li button:hover {\n  background-color: #007bff;\n  color: white;\n}\n\n/* === Modal === */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  width: 500px;\n  max-width: 90%;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* Dashboard Summary Section */\n.dashboard-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n/* Dashboard Cards */\n.dashboard-card {\n  background: #fff;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.dashboard-card h3 {\n  margin-bottom: 10px;\n  font-size: 18px;\n  color: #333;\n}\n\n.dashboard-card-value {\n  font-size: 24px;\n  font-weight: bold;\n  color: #007bff;\n}\n\n/* Dashboard Table */\n.dashboard-table {\n  width: 100%;\n  border-collapse: collapse;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n.dashboard-table th,\n.dashboard-table td {\n  text-align: left;\n  padding: 10px;\n  border: 1px solid #ddd;\n}\n\n.dashboard-table thead {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.dashboard-table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.dashboard-table tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Action Buttons */\n.dashboard-action-btn {\n  margin: 0 5px;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  color: #fff;\n  background-color: #007bff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.dashboard-action-btn:hover {\n  background-color: #0056b3;\n}\n\n.dashboard-container {\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n.dashboard-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.card {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.card:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.card h3 {\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.card p {\n  color: #666;\n  margin-bottom: 15px;\n}\n\n.card button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s ease;\n}\n\n.card button:hover {\n  background-color: #0056b3;\n}\n\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.popup-content {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.popup-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.cancel-button {\n  background: #f44336;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.cancel-button:hover {\n  background: #d32f2f;\n}\n\n/* General Table Styles */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 20px 0;\n  font-size: 16px;\n  text-align: left;\n  background-color: #f9f9f9;\n}\n\n.table thead {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ddd;\n  padding: 12px;\n}\n\n.table tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Action Buttons Container */\n.tab-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.tab-buttons button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.tab-buttons button:hover {\n  opacity: 0.9;\n}\n\n/* Edit Button */\n.tab-buttons button:nth-child(1) {\n  background-color: #008CBA; /* Blue */\n  color: white;\n}\n\n/* Delete Button */\n.tab-buttons button:nth-child(2) {\n  background-color: #f44336; /* Red */\n  color: white;\n}\n\n.modal-content {\n  max-height: 80vh;  /* Limits the height of the modal */\n  overflow-y: auto;  /* Enables vertical scrolling */\n  padding: 20px;\n  border-radius: 8px;\n  background-color: white;\n}\n\n.modal-backdrop {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 24px;\n  background: transparent;\n  border: none;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
